export const BASKET_ERROR_CODES = [
  'fast_selling_item_sold_out',
  'item_out_of_stock',
  'item_unavailable',
  'max_quantity_exceeded',
  'personalisation_illegal_characters',
  'personalisation_too_long',
] as const;

export const DEFAULT_BASKET_ERROR_MESSAGE =
  'There has been a technical issue. Please reload the page and try again or try again later.';
